"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.canCancelScheduledPost = exports.canEditScheduledPost = exports.postQueueYouTubeUrl = exports.postQueueStatusDetail = exports.postQueueStatusLabel = void 0;
const core_1 = require("@js-joda/core");
const platform_enum_1 = require("./types/platform.enum");
const post_status_enum_1 = require("./types/post_status.enum");
const youtube_media_1 = require("./youtube-media");
/** Human-readable status for the publishing queue list view. */
const postQueueStatusLabel = (post) => {
    if (post.publishStatus === "paused") {
        return "Paused";
    }
    if (post.publishStatus === "held") {
        return "Held";
    }
    if (post.publishStatus === "retrying") {
        return "Retrying";
    }
    switch (post.status) {
        case post_status_enum_1.PostStatus.FAILED:
            return "Failed";
        case post_status_enum_1.PostStatus.IN_PROGRESS:
            return "Publishing";
        case post_status_enum_1.PostStatus.SCHEDULED:
            return "Queued";
        case post_status_enum_1.PostStatus.PUBLISHED:
            return "Published";
        case post_status_enum_1.PostStatus.PENDING_APPROVAL:
            return "Pending approval";
        case post_status_enum_1.PostStatus.DRAFT:
            return "Draft";
        default:
            return post.status;
    }
};
exports.postQueueStatusLabel = postQueueStatusLabel;
/** Longer detail for tooltips (error / progress / reconnect copy). */
const postQueueStatusDetail = (post) => {
    var _a, _b, _c, _d;
    if (post.publishStatus === "paused") {
        return (_a = post.statusDetail) !== null && _a !== void 0 ? _a : "Paused — reconnect YouTube";
    }
    if (post.publishStatus === "held") {
        return ((_b = post.statusDetail) !== null && _b !== void 0 ? _b : "Held — waiting for X publishing to be available again");
    }
    if (post.publishStatus === "retrying") {
        return (_c = post.statusDetail) !== null && _c !== void 0 ? _c : "Retrying publish…";
    }
    if (post.status === post_status_enum_1.PostStatus.FAILED) {
        return post.errorMessage;
    }
    if (post.status === post_status_enum_1.PostStatus.IN_PROGRESS) {
        return (_d = post.statusDetail) !== null && _d !== void 0 ? _d : "Publishing…";
    }
    return post.statusDetail;
};
exports.postQueueStatusDetail = postQueueStatusDetail;
const postQueueYouTubeUrl = (post) => {
    if (post.platform !== platform_enum_1.Platform.YOUTUBE || !post.refId) {
        return undefined;
    }
    return `https://www.youtube.com/shorts/${post.refId}`;
};
exports.postQueueYouTubeUrl = postQueueYouTubeUrl;
/** Whether a scheduled post can still be edited (YouTube: 10 min lock before publish). */
const canEditScheduledPost = (post) => {
    if (post.status !== post_status_enum_1.PostStatus.SCHEDULED || !post.scheduledAt) {
        return true;
    }
    // Edit lock is YouTube Shorts queue only — other platforms stay editable.
    if (post.platform !== platform_enum_1.Platform.YOUTUBE) {
        return true;
    }
    const scheduled = core_1.Instant.parse(post.scheduledAt);
    const deadline = core_1.Instant.now().plus(youtube_media_1.SCHEDULE_EDIT_LOCK_MINUTES, core_1.ChronoUnit.MINUTES);
    return scheduled.isAfter(deadline);
};
exports.canEditScheduledPost = canEditScheduledPost;
/** Whether a scheduled post can be cancelled (anytime before publish). */
const canCancelScheduledPost = (post) => post.status === post_status_enum_1.PostStatus.SCHEDULED;
exports.canCancelScheduledPost = canCancelScheduledPost;
